<template>
    <v-row>
        <v-col :cols="12" style="margin-top: -50px"
               :class="{'pl-0': $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'}">

            <material-card color="green" title="Account Status">
                <v-simple-table class="account_status_card-table">
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td class="pr-0"><b>Status</b></td>
                                <td class="pl-0" align="right">
                                    <v-row>
                                        <v-spacer />
                                        <v-select
                                            style="max-width: 175px"
                                            v-model="activeAccount.account.frozen"
                                            :items="statusList"
                                            hide-details
                                            class="mt-0 pt-0 float-right"
                                            :readonly="!$store.state.auth.checkAccess({key: 'status_update', value: true})"
                                            v-on:change="toUpdate(activeAccount.account.frozen, 'frozen', 'Confirm status change')"
                                        />

                                        <default-history type="status" icon="history" title="Status Change History" />
                                    </v-row>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <v-row justify="center">
                                        <v-switch
                                            label="Activated"
                                            v-model="activeAccount.account.activated"
                                            :true-value="1"
                                            :false-value="0"
                                            :readonly="!$store.state.auth.checkAccess({key: 'status_update', value: true})"
                                            v-on:change="toUpdate(activeAccount.account.activated, 'activated', 'Confirm activation change')"
                                        />
                                    </v-row>
                                </td>
                            </tr>
                            <tr v-if="$store.state.auth.checkAccess({ key: 'blacklist', value: true })">
                                <td class="pr-0"><b>Blacklist</b></td>
                                <td class="pl-0" align="right">
                                    <v-btn
                                        small
                                        dark
                                        :disabled="blacklistLoadind"
                                        :loading="blacklistLoadind"
                                        :color="activeAccount.account.blacklisted ? 'red' : 'green'"
                                        v-text="activeAccount.account.blacklisted ? 'Blacklisted' : 'Blacklist'"
                                        @click="blacklistToggle()"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <v-text-field
                                        label="Closure Reason"
                                        placeholder=""
                                        v-model="activeAccount.account.data.closure_reason"
                                        :readonly="!$store.state.auth.checkAccess({key: 'status_update', value: true})"
                                        :append-icon="$store.state.auth.checkAccess({key: 'status_update', value: true}) ? 'mdi-content-save' : ''"
                                        @click:append="toUpdate(activeAccount.account.data.closure_reason, 'data.closure_reason', 'Confirm Closure Reason change')"
                                        hide-details
                                    ></v-text-field>
                                </td>
                            </tr>
                            <tr>
                                <td class="pr-0"><b>Type</b></td>
                                <td class="pl-0" align="right">
                                    <v-select
                                        style="width: 100px"
                                        v-model="activeAccount.account.type"
                                        :items="typeList"
                                        hide-details
                                        class="mt-0 pt-0 float-right"
                                        v-on:change="toUpdate(activeAccount.account.type, 'type', 'Confirm type change')"
                                    />
                                    <default-history class="float-right" type="type" icon="history" title="Type Change History" />
                                </td>
                            </tr>
                            <tr>
                                <td class="pr-0">
                                    <b class="text-no-wrap">VIP Manager</b>
                                </td>
                                <td class="pl-5" align="right">
                                    <template
                                        v-if="!$store.state.auth.checkAccess({key: 'vip_managers_control', value: true})"
                                    >
                                        {{ activeAccount.account.data.vip_manager_name }}
                                    </template>

                                    <v-row v-else>
                                        <v-spacer />
                                        <v-autocomplete
                                            v-model="activeAccount.account.data.vip_manager"
                                            :items="vipManagersList"
                                            :loading="vipManagersLoading"
                                            item-text="name"
                                            item-value="user_id"
                                            auto-select-first
                                            hide-details
                                            clearable
                                            class="mt-0 pt-0"
                                            style="flex: 10"
                                            v-on:change="toUpdate(activeAccount.account.data.vip_manager || null, 'data.vip_manager', 'Confirm VIP manager change')"
                                        />

                                        <default-history
                                            class="d-inline-block"
                                            type="data.vip_manager"
                                            handler="vip_manager"
                                            icon="history"
                                            title="Profile History"
                                        />
                                    </v-row>
                                </td>
                            </tr>
                            <tr>
                                <td class="pr-0">
                                  <b>Level</b>
                                  <v-tooltip v-if="hasLvlProgressInfo" bottom>
                                    <template #activator="{on, attrs}">
                                      <v-icon
                                        class="ml-1"
                                        color="info"
                                        v-on="on"
                                        v-bind="attrs"
                                      >
                                        info
                                      </v-icon>
                                    </template>
                                    <span v-text="lvlProgressText" />
                                  </v-tooltip>
                                </td>
                                <td class="pl-0" align="right">
                                  <v-row class="mx-0">
                                    <template
                                      v-if="$store.state.auth.checkAccess({key: 'level_change', value: true})"
                                    >
                                      <v-spacer />
                                      <v-combobox
                                          class="mt-0 pt-0"
                                          style="max-width: 140px"
                                          :items="levelMapItems"
                                          v-model="activeAccount.account.level"
                                          append-outer-icon="mdi-content-save"
                                          v-on:change="toUpdate($event, 'level', 'Confirm level change')"
                                          v-on:click:append-outer="$event?.target?.offsetParent?.__vue__?.blur()"
                                          hide-details
                                      />
                                      <default-history
                                          class="d-inline-block"
                                          type="level"
                                          icon="history"
                                          title="Level History"
                                      />
                                    </template>
                                    <template v-else>
                                        {{ accountLevel }}
                                    </template>

                                  </v-row>
                                </td>
                            </tr>
                            <tr>
                                <td class="pr-0">
                                  <b>Affiliate</b>
                                  <v-tooltip v-if="Object.keys(activeAccount.account.affiliate_full).length" right>
                                    <template #activator="{on, attrs}">
                                      <v-icon
                                        class="ml-1"
                                        color="info"
                                        v-on="on"
                                        v-bind="attrs"
                                      >
                                        info
                                      </v-icon>
                                    </template>
                                    <div
                                      v-text="toYAMLLike(activeAccount.account.affiliate_full, 0, '↓')"
                                      style="white-space: pre;"
                                    />
                                  </v-tooltip>
                                </td>
                                <td class="pl-0 pr-0" align="right">

                                    <v-text-field
                                        v-if="$store.state.auth.checkAccess({key: 'clean_affiliate', value: true})"
                                        v-model="activeAccount.account.affiliate"
                                        small
                                        hide-details
                                        class="col-9 mt-0 pb-0 pt-0"
                                        :readonly="!$store.state.auth.checkAccess({key: 'clean_affiliate', value: true})"
                                        :append-icon="$store.state.auth.checkAccess({key: 'clean_affiliate', value: true}) ? 'mdi-content-save' : ''"
                                        @click:append="toUpdate(activeAccount.account.affiliate, 'affiliate', 'Change affiliate BTAG?')"
                                    />
                                    <template v-else>
                                        <span class="pr-4">{{ activeAccount.account.affiliate }}</span>
                                    </template>

                                    <div v-if="activeAccount.account.affise && activeAccount.account.affise.pid" class="text-left">
                                        PID: {{ activeAccount.account.affise.pid }} <br />
                                        CID: {{ activeAccount.account.affise.clickid }}
                                    </div>
                                    <template v-else-if="activeAccount.account.clickid">
                                        <span class="pr-4">CID: {{ activeAccount.account.clickid }}</span>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </material-card>

            <material-card
              v-if="$store.state.auth.checkAccess({key: 'marketing_settings', value: true})"
              :key="activeAccount.account_id"
              color="green"
              title="Marketing Settings"
            >
                <v-simple-table>
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td><b>Autobonuses</b></td>
                                <td align="right">
                                    <default-history class="float-right" type="autobonus" icon="history" title="Type Change Autobonus" />
                                    <v-checkbox
                                        v-model="activeAccount.account.autobonus"
                                        hide-details
                                        class="ma-0"
                                        v-on:change="toUpdate(activeAccount.account.autobonus, 'autobonus', 'Confirm marketing settings Bonuses disable/enable')"
                                    ></v-checkbox>
                                </td>
                            </tr>
                            <template
                              v-for="(marketingSettingLabel, marketingSettingKey) in defaultEnabledMarketingSettings"
                            >
                                <tr
                                  :key="marketingSettingKey"
                                >
                                    <td>
                                        <b v-text="marketingSettingLabel" />
                                    </td>
                                    <td align="right">
                                        <default-history
                                          class="float-right"
                                          :type="`data.promo.${marketingSettingKey}`"
                                          icon="history"
                                          handler="promo"
                                          :title="`Type Change ${marketingSettingLabel}`"
                                        />
                                        <v-checkbox
                                            v-model="activeAccount.account.data.promo[marketingSettingKey]"
                                            class="ma-0"
                                            hide-details
                                            v-on:change="toUpdate(activeAccount.account.data.promo[marketingSettingKey], `data.promo.${marketingSettingKey}`, `Confirm toggle marketing setting ${marketingSettingLabel}`)"
                                        />
                                    </td>
                                </tr>
                            </template>
                            <template
                              v-for="(luckyboxSettingLabel, luckyboxSettingKey) in defaultEnabledLuckyboxSettings"
                            >
                                <tr
                                  :key="luckyboxSettingKey"
                                >
                                    <td>
                                        <b v-text="luckyboxSettingLabel" />
                                    </td>
                                    <td align="right">
                                        <default-history
                                          class="float-right"
                                          :type="`data.promo.luckybox.${luckyboxSettingKey}`"
                                          icon="history"
                                          handler="promo"
                                          :title="`Type Change ${luckyboxSettingLabel}`"
                                        />
                                        <v-checkbox
                                            v-model="activeAccount.account.data.promo.luckybox[luckyboxSettingKey]"
                                            class="ma-0"
                                            hide-details
                                            v-on:change="toUpdate(activeAccount.account.data.promo.luckybox[luckyboxSettingKey], `data.promo.luckybox.${luckyboxSettingKey}`, `Confirm toggle marketing setting ${luckyboxSettingLabel}`)"
                                        />
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </template>
                </v-simple-table>
            </material-card>

            <material-card
              v-if="!$store.state.auth.checkAccess({key: 'hide_responsible_gaming', value: true})"
              color="green"
              title="Responsible gaming"
            >
                <v-simple-table class="pb-0">
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td><b>Deny Deposit</b></td>
                                <td align="right">
                                    <v-row
                                        align="center"
                                        justify="center"
                                    >
                                        <v-switch
                                            class="ma-0"
                                            v-model="activeAccount.account.data.access_limit.payment"
                                            hide-details
                                            v-on:change="toUpdate(activeAccount.account.data.access_limit.payment, 'data.access_limit.payment', 'Confirm payment access disable/enable')"
                                        />
                                        <default-history
                                            class="float-right"
                                            handler="default"
                                            type="data.access_limit.payment"
                                            icon="history"
                                            title="Status Change History"
                                        />
                                    </v-row>
                                </td>
                            </tr>
                            <tr>
                                <td><b>Deny Withdraw</b></td>
                                <td align="right">
                                    <v-row
                                        align="center"
                                        justify="center"
                                    >
                                        <v-switch
                                            class="ma-0"
                                            v-model="activeAccount.account.data.access_limit.withdraw"
                                            hide-details
                                            v-on:change="toUpdate(activeAccount.account.data.access_limit.withdraw, 'data.access_limit.withdraw', 'Confirm withdraw access disable/enable')"
                                        />
                                        <default-history
                                            class="float-right"
                                            handler="default"
                                            type="data.access_limit.withdraw"
                                            icon="history"
                                            title="Status Change History"
                                        />
                                    </v-row>
                                </td>
                            </tr>
                            <tr>
                                <td><b>Deny Fast Withdraw</b></td>
                                <td align="right">
                                    <v-row
                                        align="center"
                                        justify="center"
                                    >
                                        <v-switch
                                            class="ma-0"
                                            v-model="activeAccount.account.data.access_limit.fast_withdraw"
                                            hide-details
                                            v-on:change="toUpdate(activeAccount.account.data.access_limit.fast_withdraw, 'data.access_limit.fast_withdraw', 'Confirm fast withdraw access disable/enable')"
                                        />
                                        <default-history
                                            class="float-right"
                                            handler="default"
                                            type="data.access_limit.fast_withdraw"
                                            icon="history"
                                            title="Status Change History"
                                        />
                                    </v-row>
                                </td>
                            </tr>
                            <tr>
                                <td><b>Deny Games</b></td>
                                <td align="right">
                                    <v-row
                                        align="center"
                                        justify="center"
                                    >
                                        <v-switch
                                            class="ma-0"
                                            v-model="activeAccount.account.data.access_limit.game"
                                            hide-details
                                            v-on:change="toUpdate(activeAccount.account.data.access_limit.game, 'data.access_limit.game', 'Confirm game access disable/enable')"
                                        />
                                        <default-history
                                            class="float-right"
                                            handler="default"
                                            type="data.access_limit.game"
                                            icon="history"
                                            title="Status Change History"
                                        />
                                    </v-row>
                                </td>
                            </tr>
                            <tr>
                              <td><b>Express Withdrawal</b></td>
                              <td align="right">
                                <v-row
                                  align="center"
                                  justify="center"
                                >
                                  <v-switch
                                    v-model="activeAccount.account.data.express_withdrawal.is_enabled"
                                    class="ma-0"
                                    hide-details
                                    v-on:change="toUpdate(activeAccount.account.data.express_withdrawal.is_enabled, 'data.express_withdrawal.is_enabled', 'Confirm express withdrawal access disable/enable')"
                                  />

                                  <default-history
                                    class="float-right"
                                    handler="default"
                                    type="data.express_withdrawal.is_enabled"
                                    icon="history"
                                    title="Express Withdrawal Access History"
                                  />
                                </v-row>
                              </td>
                            </tr>
                            <tr v-if="activeAccount.account.data.express_withdrawal.is_enabled">
                              <td><b>Express Withdrawal Fee %</b></td>
                              <td align="right">
                                <v-row
                                  align="center"
                                  justify="center"
                                >
                                  <v-text-field
                                    v-model.number="activeAccount.account.data.express_withdrawal.fee_percentage"
                                    class="flex-grow-0 mr-1"
                                    prefix="%"
                                    min="0"
                                    max="100"
                                    type="number"
                                    dense
                                    hide-details
                                  />
                                  <v-btn
                                    color="primary"
                                    icon
                                    @click="toUpdate(activeAccount.account.data.express_withdrawal.fee_percentage, 'data.express_withdrawal.fee_percentage', 'Confirm express withdrawal fee percentage change')"
                                  >
                                    <v-icon>
                                      mdi-content-save
                                    </v-icon>
                                  </v-btn>

                                  <default-history
                                    class="float-right"
                                    handler="default"
                                    type="data.express_withdrawal.fee_percentage"
                                    icon="history"
                                    title="Express Withdrawal Fee % History"
                                  />
                                </v-row>
                              </td>
                            </tr>
                            <tr :class="riskLevelColor[activeAccount.account.data.risk_level]">
                                <td><b>Risk Level</b></td>
                                <td align="right">
                                    <v-select
                                        style="max-width: 70px"
                                        v-model="activeAccount.account.data.risk_level"
                                        :items="riskLevel"
                                        hide-details
                                        class="mt-0 pt-0"
                                        :readonly="!$store.state.auth.checkAccess({key: 'kyc_verification', value: true})"
                                        v-on:change="toUpdate(activeAccount.account.data.risk_level, 'data.risk_level', 'Confirm Risk level change')"
                                    />
                                </td>
                            </tr>
                            <tr v-if="$store.state.auth.checkAccess({key: 'bet_limits', value: true})">
                                <td colspan="2">
                                    <bet-limits :btn="{color: 'success'}" :account="activeAccount.account" />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </material-card>

        </v-col>
    </v-row>
</template>

<style>
    .custom_label > label div {
        vertical-align: super;
        display: inline-block;
        cursor: pointer;
        user-select: none;
        line-height: 24px;
    }
</style>

<script>
    import { get, set, find, map } from 'lodash'
    import { mask } from 'vue-the-mask'
    import { API } from '@/utils/api'
    import { findParentComponentByTag } from '@/utils/helper'
    import { mapGetters } from 'vuex'
    import BetLimits from '@/components/game/BetLimits'
    import DefaultHistory from '@/components/helper/DefaultHistory'

    export default {

        props: [],

        directives: {
            mask,
        },
        components: {
            BetLimits, DefaultHistory
        },

        data: () => ({
            mainView: null,
            updateUrls: {
                default: '/$v/account/update.json',
                level: '/$v/account/level/change.json',
            },
            statusList: [
                { text: 'Open', value: 0 },
                { text: 'Closed', value: 1 },
                { text: 'Frozen', value: 2 },
                { text: 'Temporary Frozen', value: 3 },
                { text: 'Self Exclusion Permanent', value: 4 },
                { text: 'Frozen by Refund', value: 5 },
                { text: 'Frozen by Security Answer', value: 6 },
                { text: 'Not Verified', value: 7 },
                { text: 'Closed by Regulator', value: 8 },
                { text: 'Closed by License', value: 9 },
                { text: 'Gambling Addiction', value: 10 },
                { text: 'Frozen by Suspicion', value: 11 },
                { text: 'Closed by Antifraud', value: 12 },
                { text: 'Closed by Chargeback', value: 13 },
            ],
            vipManagersList: [],
            vipManagersLoading: false,
            blacklistLoadind: false,
            riskLevel: [
                1, 2, 3, 4, 5
            ],
            riskLevelColor: {
                1: 'success',
                2: 'green lighten-2',
                3: 'lime lighten-2',
                4: 'orange lighten-2',
                5: 'error',
            },
            typeList: [
                'casino', 'sport', 'test', 'affiliate'
            ],
            defaultEnabledMarketingSettings: {
                email: 'Retention Emails',
                sms: 'Promo SMS',
                transactional_emails: 'Transactional Emails',
                wheel_of_fortune: 'Wheel Of Fortune',
                achievements: 'Achievements',
                daily_missions: 'Daily Missions',
                loyalty_points: 'Loyalty Points',
                shop: 'Shop',
                cashback: 'Cashback',
                whatsapp: 'WhatsApp',
                manual_bonus_issuance: 'Manual Bonus Issuance',
            },

            defaultEnabledLuckyboxSettings: {
              loyalty_purchase: 'Luckybox Loyalty Purchase',
              cash_purchase: 'Luckybox Cash Puchase',
            },
        }),

        computed: {
            ...mapGetters({ activeAccount: 'account/active' }),
            accountStatus: function () {
                if (this.activeAccount.account.frozen == 0) {
                    return 'Open'
                } else {
                    return 'Closed'
                }
            },

            levelMap: function () {
                return this.activeAccount.account.levelMap || {
                    0: 'None',
                    1: 'Bronze',
                    2: 'Silver',
                    3: 'Gold',
                    4: 'Platinum',
                    5: 'Diamond',
                }
            },

            levelMapItems: function () {
                return map(this.levelMap, (value, text) => ({ value, text }))
            },

            accountLevel: function () {
                return this.levelMap[this.activeAccount.account.level] || this.levelMap[1] || this.activeAccount.account.level
            },

            hasLvlProgressInfo() {
              return this.activeAccount.account.level_progress?.next > 0 &&
                     this.activeAccount.account.level_progress.left > 0
            },

            lvlProgressText() {
              if (this.hasLvlProgressInfo) {
                const levelProgress = this.activeAccount.account.level_progress
                return `Progress towards next lvl: ${(Math.abs(levelProgress.left - levelProgress.next)).toFixed(2)} / ${levelProgress.next}`
              }

              return 'N/A'
            },
        },

        created () {
            this.mainView = findParentComponentByTag(this, 'user-main-view')
        },

        mounted () {
            this.loadUserList()
        },

        methods: {
            loadUserList () {
                if (this.$store.state.auth.checkAccess({ key: 'vip_managers_control', value: true })) {
                    this.vipManagersLoading = true
                    return API.call('/users/vip_managers_list.json').then(resp => {
                        this.vipManagersList = resp.data
                        return resp.data
                    }).catch(e => {
                    }).finally(() => {
                        this.vipManagersLoading = false
                    })
                }
            },

            blacklistToggle () {
                if (this.$store.state.auth.checkAccess({ key: 'blacklist', value: true })) {
                    this.blacklistLoadind = true
                    API.call('/$v/account/update.json', {
                        login: this.activeAccount.account.login,
                        account_id: this.activeAccount.account.account_id,
                        fields: { blacklisted: !this.activeAccount.account.blacklisted },
                    }, this.activeAccount.account).then(resp => {

                        this.activeAccount.account.blacklisted = !this.activeAccount.account.blacklisted
                        for (let k of Object.keys(resp.data)) {
                            set(this.activeAccount.account, k, get(resp.data, k))
                            set(this.activeAccount.initAccount, k, get(resp.data, k))
                        }

                        return resp.data
                    }).finally(() => {
                        this.blacklistLoadind = false
                    })
                }
            },

            toUpdate: async function (val, field, message) {

                if(val instanceof PointerEvent) {
                  val =  get(this.activeAccount.account, field, val)
                }

                if (await this.$root.$confirm('Confirm', message)) {

                    let fields = { [field]: val }
                    let init_fields = { [field]: get(this.activeAccount.initAccount, field, val) }

                    if (field == 'frozen') {

                        let status = find(this.statusList, { value: fields.frozen })
                        if (status) fields.status_text = status.text

                        let initStatus = find(this.statusList, { value: init_fields.frozen })
                        if (initStatus) init_fields.status_text = initStatus.text

                    }

                    let params = {
                        login: this.activeAccount.account.login,
                        account_id: this.activeAccount.account.account_id,
                        fields,
                        init_fields,
                    }

                    if (field == 'level') {
                        params.currency = this.activeAccount.account.currency
                    }

                    API.call(this.updateUrls[field] || this.updateUrls.default, params, this.activeAccount.account).then(resp => {

                        set(this.activeAccount.initAccount, field, get(resp.data, field))

                        return resp.data

                    }).then(r => {
                        this.$showSuccess('Account updated')
                    }).catch(e => {
                    })

                } else {
                    this.$nextTick(() => {
                        set(this.activeAccount.account, field, get(this.activeAccount.initAccount, field))
                    })
                }
            },

            toYAMLLike(object, indent = 0, newLevelIndicator = '') {
              const leftPadding = ' '.repeat(indent)
              let result = ''

              for (const key in object) {
                if (typeof object[key] === 'object' && !!object[key]) {
                  result += `${leftPadding}${key}:${newLevelIndicator}\n`
                  result += this.toYAMLLike(object[key], indent + 1, newLevelIndicator)
                } else {
                  result += `${leftPadding}${key}: ${object[key]}\n`
                }
              }

              return result
            }
        },

    }
</script>
